// Lazy loader for Google Maps JS API (Places + Marker). Only loads once.
let loadPromise: Promise<any> | null = null;

declare global {
  interface Window {
    __gmapsInitCb?: () => void;
    google: any;
  }
}

export function loadGoogleMaps(): Promise<any> {
  if (typeof window === "undefined") return Promise.reject(new Error("SSR"));
  if (window.google?.maps) return Promise.resolve(window.google);
  if (loadPromise) return loadPromise;

  const key = import.meta.env['VITE_LOVABLE_CONNECTOR_GOOGLE_MAPS_BROWSER_KEY'];
  const channel = import.meta.env['VITE_LOVABLE_CONNECTOR_GOOGLE_MAPS_TRACKING_ID'];
  if (!key) return Promise.reject(new Error("Missing Google Maps browser key"));

  loadPromise = new Promise((resolve, reject) => {
    window.__gmapsInitCb = () => resolve(window.google);
    const s = document.createElement("script");
    const channelParam = channel ? `&channel=${channel}` : "";
    s.src = `https://maps.googleapis.com/maps/api/js?key=${key}&loading=async&libraries=places,marker,geometry&callback=__gmapsInitCb${channelParam}`;
    s.async = true;
    s.defer = true;
    s.onerror = () => reject(new Error("Google Maps script failed to load"));
    document.head.appendChild(s);
  });
  return loadPromise;
}
